export class PutAdresse {
  public structure_LocaliteId?: number;
  public structure_RueId?: number;
  public structure_RueNumero?: string;
  public structure_RueBoite?: string;
  public langueId?: number;
  public impression_Adresse?: string;
  public impression_CodePostal?: string;
  public impression_Localite?: string;
  public impression_Pays?: string;
  public telephone?: string;
  public fax?: string;
  public gsm?: string;
  public site?: string;
  public mail?: string;
}
